<template>
  <!-- 是否只读
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item label="是否只读"> 
      <el-radio-group v-model="isReadonly" size="small">
        <el-radio-button :label="false">否</el-radio-button>
        <el-radio-button :label="true">是</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 是否只读
     *  @description 将 isReadonly 字段映射到当前 isReadonly 计算属性
     *  @return {Boolean}
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    ...mapComputed({
      isReadonly: { 
        parent: i => i.baseOption,
        attr: "isReadonly",
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingIsReadonly.vue